import angular from 'angular';

import CtaButtonBuilderRowComponent from './cta-button-builder-row.component';

const CtaButtonBuilderRowModule = angular
    .module('control-room.commons.form.components.cta-button-builder-row', [])
    .component('crCtaButtonBuilderRow', CtaButtonBuilderRowComponent);

export default CtaButtonBuilderRowModule;
